import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4868aeb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mxa-message-normal-top",
  "data-test": "data-top"
}
const _hoisted_2 = {
  class: "mxa-message-normal-body",
  "data-test": "data-body"
}

import { computed, PropType } from 'vue'
import { NormalMsgState } from '@/model/components/common/message/normalMessage'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'NormalMessage',
  props: {
  // 正常情報
  normal: {
    type: Object as PropType<NormalMsgState>,
    default: () => ({ data: [] }),
  },
},
  setup(__props) {

const props = __props

log.trace(`NormalMessage setup start.`)
// プロパティ定義


// データ有無の判定
const isData = computed(() => props.normal.data.length > 0)

log.trace(`NormalMessage setup end.`)

return (_ctx: any,_cache: any) => {
  return (_unref(isData))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.normal.data, (error, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(error.key)), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})